class KsSimpleCollections extends HTMLElement {
  constructor() {
    super();
    this.list = this.querySelector('.ks-simple-collections-list');
    this.activeItem = this.querySelector('.ks-simple-collections-list-item.active');
  }

  connectedCallback() {
    if (!this.list || !this.activeItem) return;

    // Use IntersectionObserver to run the script only when the section is visible
    const observer = new IntersectionObserver((entries, observer) => {
      if (entries[0].isIntersecting) {
        this.init();
        observer.disconnect(); // We only need to run this once
      }
    });
    observer.observe(this);
  }

  init() {
    this.centerActiveItem();
    // Re-center on window resize to handle orientation changes
    window.addEventListener('resize', this.debounce(this.centerActiveItem.bind(this), 200));
  }
  
  centerActiveItem() {
    // Only perform the scroll on mobile-sized viewports
    if (window.matchMedia('(min-width: 990px)').matches) {
      // On desktop, ensure scroll position is reset if needed
      this.list.scrollTo({ left: 0 });
      return;
    }

    // Use requestAnimationFrame to ensure layout calculations are accurate
    requestAnimationFrame(() => {
      const listRect = this.list.getBoundingClientRect();
      const itemRect = this.activeItem.getBoundingClientRect();

      // Calculate the scroll position to center the active item
      const scrollLeft = (itemRect.left - listRect.left) - (listRect.width / 2) + (itemRect.width / 2);
      
      this.list.scrollTo({
        left: this.list.scrollLeft + scrollLeft, // Scroll relative to current position
        behavior: 'smooth'
      });
    });
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

if (!customElements.get('ks-simple-collections')) {
  customElements.define('ks-simple-collections', KsSimpleCollections);
}